import { Component, computed, inject } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';

import { AuthService } from '../../auth/services/auth.service';
import { IAppState } from '../../store/interface/app.state.interface';
import { LOGIN_ROUTE } from '../../core/constant/route.constant';
import { selectLoggedInUser } from '../../store/user/user.selectors';
import { TokenStoreService } from '../../core/services/token-store.service';
import { getFullName } from '../../shared/utils/string.util';
import { getRoleLabel } from '../../core/utils/user.util';
import * as UserActions from '../../store/user/user.actions';

@Component({
    standalone: false,
    selector: 'app-profile-menu',
    templateUrl: './profile-menu.component.html',
})
export class ProfileMenuComponent {
    private readonly authService = inject(AuthService);
    private readonly router = inject(Router);
    private readonly store = inject(Store<IAppState>);
    private readonly tokenStore = inject(TokenStoreService);

    protected readonly loggedInUser = this.store.selectSignal(selectLoggedInUser);

    protected readonly displayName = computed(() => {
        const user = this.loggedInUser();
        return user ? getFullName(user.person) : '';
    });

    protected readonly roleLabel = computed(() => {
        const user = this.loggedInUser();
        return user ? getRoleLabel(user) : null;
    });

    // replaceUrl, so Back cannot return to a page that needs the sign-in.
    protected logout(): void {
        this.authService.logout().finally(() => {
            this.tokenStore.clear();
            this.store.dispatch(UserActions.setLoggedInUser({ user: null }));
            void this.router.navigateByUrl(LOGIN_ROUTE, { replaceUrl: true });
        });
    }
}
